
import { CbxVariablesModule } from '@/store/modules/CbxVariablesModule';
import { Component, Vue } from 'vue-property-decorator';
import { ProductSearchResultProduct } from '../../models/Product';
import ProductDetailsModule from '../../store/modules/ProductDetailsModule';
import RequestPriceButton from '../RequestPriceButton.vue';

@Component({
    name: 'DetailsRequestPriceButton',
    components: {
        RequestPriceButton
    }
})
export default class DetailsRequestPriceButton extends Vue {
    get product(): ProductSearchResultProduct {
        return ProductDetailsModule.PRODUCT;
    }

    get sku(): string {
        if (ProductDetailsModule.VARIANTS?.length > 0) {
            return ProductDetailsModule.SELECTED_VARIANT?.sku;
        }
        return this.product?.id;
    }

    get signedIn(): boolean {
        return CbxVariablesModule.VARIABLES?.signinstatus;
    }
}
